(function IIFE() {
    'use strict';

    /////////////////////////////

    function FeedSubscribersFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/feed/subscribers/:methodKey', {}, {
            saveSubscription: {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'save',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('FeedSubscribersFactory', FeedSubscribersFactory);
})();
